import { Store, ShoppingCart } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const ROLES = [
  { v: "seller", l: "بائع", d: "أضف مزادات وإعلانات بيع وإيجار ووظائف", icon: Store },
  { v: "buyer", l: "مشتري", d: "زايد على المزادات واطلب التواصل مع المعلنين", icon: ShoppingCart },
];

export const roleLabel = (r) => ROLES.find((x) => x.v === r)?.l;

export const RoleChooser = ({ onDone }) => {
  const { user, setUser } = useAuth();
  const pick = async (role) => {
    try {
      const { data } = await api.put("/me/role", { role });
      setUser(data);
      toast.success(`تم تحديد نوع الحساب: ${roleLabel(role)}`);
      onDone?.(data);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="grid grid-cols-2 gap-3" data-testid="role-chooser">
      {ROLES.map((r) => (
        <button key={r.v} type="button" data-testid={`role-${r.v}`} onClick={() => pick(r.v)}
          className={`rounded-xl border-2 p-4 text-center transition-colors ${user?.role === r.v ? "border-brand bg-brand/10" : "hover:border-brand"}`}>
          <r.icon size={20} className="mx-auto text-slate-600 mb-2" />
          <div className="font-bold">{r.l}</div>
          <div className="text-xs text-slate-500 mt-1">{r.d}</div>
        </button>
      ))}
    </div>
  );
};
